import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-row p-2 align-items-center" };
const _hoisted_2 = { class: "flex flex-column" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = ["href"];
const _hoisted_6 = { key: 2 };
import Toast from "primevue/toast";
import Secrets from "@/onedesk-portal.usersecrets.json";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomToast',
    setup(__props) {
        const addAccessSignatureToDownloadLink = (link) => link + Secrets.AZURE.wpSharedAccessSignature;
        const getIconBySeverity = (severity) => {
            switch (severity) {
                case "success":
                    return "pi pi-check";
                case "error":
                    return "pi pi-times";
                case "warning":
                    return "pi pi-exclamation-triangle";
                case "info":
                    return "pi pi-info-circle";
                default:
                    return "pi pi-info-circle";
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Toast), {
                position: "top-right",
                group: "standard"
            }, {
                message: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("i", {
                            class: _normalizeClass(getIconBySeverity(slotProps.message.severity)),
                            style: { "font-size": "1.5rem", "margin-right": "1rem" }
                        }, null, 2),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                (slotProps.message.summary)
                                    ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(slotProps.message.summary), 1))
                                    : _createCommentVNode("", true),
                                (slotProps.message.detail.downloadPath)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                                        _createElementVNode("a", {
                                            class: "wp-toast-view-result-link",
                                            href: addAccessSignatureToDownloadLink(slotProps.message.detail.downloadPath),
                                            download: ""
                                        }, " Download ", 8, _hoisted_5)
                                    ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(slotProps.message.detail), 1))
                            ])
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
